import tick from '../../../images/icon/tick-square.svg';

export const MetricsSection = () => {
  const TableRow = ({ metric, traditional, npi, isLast = false }) => {
    return (
      <tr>
        <td
          className={`bg-blue-50 text-base font-[600] px-6 py-4 border border-gray-200 ${
            isLast ? 'rounded-bl-2xl' : ''
          }`}
        >
          {metric}
        </td>
        <td className="bg-blue-50 text-[18px] px-6 py-4 border border-gray-200">
          {traditional}
        </td>
        <td
          className={`bg-green-50 text-[18px] px-6 py-4 border border-gray-200 ${
            isLast ? 'rounded-br-2xl' : ''
          }`}
        >
          <div className="flex items-start gap-2">
            <img src={tick} alt="tick" className="w-5 h-5 mt-1" />
            <span>{npi}</span>
          </div>
        </td>
      </tr>
    );
  };

  const ComparisonTable = () => {
    return (
      <div className="w-full flex justify-center px-4">
        {/* Outer container with max width */}
        <div className="w-full max-w-[1064px]">
          {/* Inner scrollable wrapper */}
          <div className="overflow-x-auto rounded-2xl shadow-lg border border-gray-200">
            <table className="min-w-[768px] w-full table-fixed text-left text-gray-800">
              <thead>
                <tr>
                  <th className="bg-blue-100 text-[22px] font-semibold px-6 py-4 border border-gray-200 w-1/3">
                    METRIC
                  </th>
                  <th className="bg-blue-100 text-[22px] font-semibold px-6 py-4 border border-gray-200 w-1/3">
                    TRADITIONAL SOURCING
                  </th>
                  <th className="bg-[#6CC11E] text-[22px] font-semibold px-6 py-4 text-white border border-gray-200 w-1/3 rounded-tr-2xl">
                    NPI-TARGETED CAMPAIGNS
                  </th>
                </tr>
              </thead>
              <tbody className="text-sm md:text-base">
                <TableRow
                  metric="DAYS TO FILL"
                  traditional="129–135 days"
                  npi="Often reduced by 20+ days"
                />
                <TableRow
                  metric="COST PER LEAD"
                  traditional="$278 (job board avg)"
                  npi="~$120 (qualified NPI lead)"
                />
                <TableRow
                  metric="REVENUE LOST PER DAY (UNFILLED ROLE)"
                  traditional="$6,575/day"
                  npi="Faster fills = faster ROI"
                />
                <TableRow
                  metric="TIME SPENT SOURCING"
                  traditional="~45 hrs/candidate"
                  npi="< 1 hr/month using pre-qualified lists"
                  isLast
                />
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="py-[40px] lg:py-[80px]">
      <h1 className="text-[30px] lg:text-[50px] text-center font-bold mb-4">
        Metrics That Matter to Hospital Teams
      </h1>
      <p className="text-[18px] text-center mb-3">
        This is not about replacing existing tools—it’s about complementing them
        with a strategy that reflects how HCPs actually move through career
        decisions.
      </p>
      <p className="font-[500] text-[22px] text-[#2F72BD] text-center mb-8">
        Here’s what hospitals typically gain by shifting more focus to the
        passive market:
      </p>
      <ComparisonTable />
    </div>
  );
};
